// Currency stores show whole-dollar prices without cents (e.g. "$20" not
// "$20.00"); fractional cents still show two decimals (e.g. "$19.99"). Never
// used for loyalty point values, which have no concept of cents.
export const formatCurrency = (cents) => {
	const dollars = cents / 100;
	return Number.isInteger(dollars) ? `$${dollars}` : `$${dollars.toFixed(2)}`;
};

// Anticipated ship dates are plain calendar days ('YYYY-MM-DD') in the
// plant's timezone. Read the parts directly -- new Date('2026-10-22') is UTC
// midnight, which renders as the previous day anywhere in the US.
export const formatShipDate = (value) => {
	const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
	if (!match) return '-';
	const [, yyyy, mm, dd] = match;
	return `${mm}-${dd}-${yyyy}`;
};

// Timestamps (order dates, decisions, shipments) as MM-DD-YYYY in the
// viewer's local time, matching formatShipDate's layout.
export const formatDate = (value, { pad = true } = {}) => {
	if (!value) return '-';
	const date = new Date(value);
	const mm = pad ? String(date.getMonth() + 1).padStart(2, '0') : String(date.getMonth() + 1);
	const dd = pad ? String(date.getDate()).padStart(2, '0') : String(date.getDate());
	return `${mm}-${dd}-${date.getFullYear()}`;
};

// Today's calendar day in the plant's timezone (America/New_York), as
// 'YYYY-MM-DD' -- the earliest anticipated ship date the API accepts.
export const shipCalendarToday = () =>
	new Intl.DateTimeFormat('en-CA', {
		timeZone: 'America/New_York',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(new Date());

export const isWeekendDate = (value) => {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
	if (!match) return false;
	const day = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]))).getUTCDay();
	return day === 0 || day === 6;
};
